import { Trans } from '@lingui/react/macro'
import { Skeleton } from 'designSystem/components/Skeleton'
import { Text } from 'designSystem/components/Text'
import { useFimSubject } from 'features/fim'
import { electionTarget } from 'features/fim/photos/photoElections'
import type { FC } from 'react'
import styled from 'styled-components'

import { PhotoModeSubjectPhotos } from './PhotoModeSubjectPhotos'

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

const LoadingStrip = styled(Skeleton)`
  width: 100%;
  height: 4rem;
`

export const PhotoModeSubjectSection: FC<{
  siteId: string
  subjectUid: string
}> = ({ siteId, subjectUid }) => {
  const { subject, notFound, error, isLoading } = useFimSubject(
    siteId,
    subjectUid
  )

  if (error || notFound) {
    return (
      <Text variant='caption' color='muted'>
        <Trans>This Subject could not be loaded. Tap another highlight.</Trans>
      </Text>
    )
  }

  if (isLoading || !subject) {
    return <LoadingStrip />
  }

  return (
    <Stack>
      <Text variant='label'>{subject.data.name}</Text>
      {electionTarget(siteId, subject) ? (
        <PhotoModeSubjectPhotos siteId={siteId} subject={subject} />
      ) : (
        <Text variant='caption' color='muted'>
          <Trans>
            Photos can be attached once this Subject has a tag or name alias.
          </Trans>
        </Text>
      )}
    </Stack>
  )
}
